module.exports = __webpack_public_path__ + "static/media/IconListAtiva.adeb631e.svg";